var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spnod-messages border rounded d-flex flex-column h-100 w-100 p-2 position-absolute"
  }, [_c('h4', {
    staticClass: "h4 text-center mb-4"
  }, [_vm._v("Message Details")]), _vm._v(" "), (_vm.message && _vm.message.client) ? _c('div', {
    staticClass: "w-100 h-100 d-flex flex-column p-0 overflow-auto"
  }, [_c('div', {
    staticClass: "spnod-admin__account--section mx-auto"
  }, [(_vm.getMyInfo.hasRoles && _vm.clientAvatar) ? _c('img', {
    staticClass: "rounded",
    attrs: {
      "src": _vm.clientAvatar,
      "width": "200px",
      "height": "200px"
    }
  }) : (_vm.nutritionistAvatar) ? _c('img', {
    staticClass: "rounded",
    attrs: {
      "src": _vm.nutritionistAvatar,
      "width": "200px",
      "height": "200px"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "spnod-admin__account--section"
  }, [_c('h5', {
    staticClass: "spnod-admin__account--header"
  }, [_vm._v("Client")]), _vm._v(" "), _c('b-row', {
    staticClass: "spnod-admin__account--row"
  }, [_c('b-col', [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.message.client.name))])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "spnod-admin__account--row"
  }, [_c('b-col', [_c('span', {
    staticClass: "text-primary cursor-pointer",
    on: {
      "click": _vm.redirectToUserAccount
    }
  }, [_vm._v("Link to Account")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "spnod-admin__account--section"
  }, [_c('h5', {
    staticClass: "spnod-admin__account--header"
  }, [_vm._v("Nutritionist")]), _vm._v(" "), _c('b-row', {
    staticClass: "spnod-admin__account--row"
  }, [_c('b-col', [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.message.client.nutritionist ? _vm.message.client.nutritionist.name : ''))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "spnod-admin__account--section"
  }, [_c('h5', {
    staticClass: "spnod-admin__account--header"
  }, [_vm._v("Additional Participants")]), _vm._v(" "), _c('ul', _vm._l((_vm.participants), function(participant) {
    return _c('li', {
      staticClass: "spnod-admin__form--list"
    }, [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v("Name: ")]), _vm._v(_vm._s(participant.name) + "\n        ")])
  }), 0)]), _vm._v(" "), (_vm.getMyInfo.hasRoles) ? _c('div', {
    staticClass: "spnod-admin__account--section"
  }, [_c('h5', {
    staticClass: "spnod-admin__account--header"
  }, [_vm._v("Biometrics")]), _vm._v(" "), (_vm.biometrics) ? _c('ul', _vm._l((_vm.biometrics), function(question) {
    return _c('li', {
      staticClass: "spnod-admin__form--list pb-2"
    }, [_c('b-row', {
      staticClass: "mx-0"
    }, [_vm._v(_vm._s(question.question))]), _vm._v(" "), _c('b-row', {
      staticClass: "mx-0"
    }, [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(question.answer))])])], 1)
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getMyInfo.hasRoles) ? _c('div', {
    staticClass: "spnod-admin__account--section"
  }, [_c('h5', {
    staticClass: "spnod-admin__account--header"
  }, [_vm._v("Surveys")]), _vm._v(" "), (_vm.questions) ? _c('ul', _vm._l((_vm.questions), function(question) {
    return _c('li', {
      staticClass: "spnod-admin__form--list pb-2"
    }, [_c('b-row', {
      staticClass: "mx-0"
    }, [_vm._v(_vm._s(question.question))]), _vm._v(" "), _c('b-row', {
      staticClass: "mx-0"
    }, [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(question.answer))])])], 1)
  }), 0) : _vm._e()]) : _vm._e()]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d5753d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Messaging/MessageDetails.vue
// module id = PdOm
// module chunks = 2